const urls = {
  home: "/",
  "jobs for electrician": "/jobs/electrician",
  "jobs for plumber": "/jobs/plumber",
  "jobs for mechanic": "/jobs/mechanic",
  "jobs for cooking": "/jobs/cooking",
  "jobs for peon": "/jobs/peon",
  "jobs for driver": "/jobs/driver",
  "jobs for drivers": "/jobs/driver",
  "jobs for housekeeping": "/jobs/housekeeping",
  "jobs for site workers": "/jobs/siteworkers",
  "jobs for securityguard": "/jobs/securityguard",
  "jobs for security guard": "/jobs/securityguard",
  electrician: "/jobs/electrician",
  plumber: "/jobs/plumber",
  mechanic: "/jobs/mechanic",
  cooking: "/jobs/cooking",
  peon: "/jobs/peon",
  driver: "/jobs/driver",
  drivers: "/jobs/driver",
  housekeeping: "/jobs/housekeeping",
  siteworkers: "/jobs/siteworkers",
  "site workers": "/jobs/siteworkers",
  securityguard: "/jobs/securityguard",
  "security guard": "/jobs/securityguard",
  "electrician jobs": "/jobs/electrician",
  "plumber jobs": "/jobs/plumber",
  "mechanic jobs": "/jobs/mechanic",
  "cooking jobs": "/jobs/cooking",
  "peon jobs": "/jobs/peon",
  "driver jobs": "/jobs/driver",
  "drivers jobs": "/jobs/driver",
  "housekeeping jobs": "/jobs/housekeeping",
  "site workers jobs": "/jobs/siteworkers",
  "securityguard jobs": "/jobs/securityguard",
  "security guard jobs": "/jobs/securityguard",
  "electrician job": "/jobs/electrician",
  "plumber job": "/jobs/plumber",
  "mechanic job": "/jobs/mechanic",
  "cooking job": "/jobs/cooking",
  "peon job": "/jobs/peon",
  "driver job": "/jobs/driver",
  "drivers job": "/jobs/driver",
  "housekeeping job": "/jobs/housekeeping",
  "site workers job": "/jobs/siteworkers",
  "securityguard job": "/jobs/securityguard",
  "security guard job": "/jobs/securityguard",
  "job for electrician": "/jobs/electrician",
  "job for plumber": "/jobs/plumber",
  "job for mechanic": "/jobs/mechanic",
  "job for cooking": "/jobs/cooking",
  "job for peon": "/jobs/peon",
  "job for driver": "/jobs/driver",
  "job for drivers": "/jobs/driver",
  "job for housekeeping": "/jobs/housekeeping",
  "job for site workers": "/jobs/siteworkers",
  "job for securityguard": "/jobs/securityguard",
  "job for security guard": "/jobs/securityguard",
  "bijali Karigar ki Naukari chahiye": "/jobs/electrician",
  "plumber ki job chahiye": "/jobs/plumber",
  "Kriya Vidhi ki Naukari chahiye": "/jobs/mechanic",
  "Kriya Vidhi ki Naukari": "/jobs/mechanic",
  "Bawarchi ki Naukari chahiye": "/jobs/cooking",
  "chaprasi ki Naukari chahiye": "/jobs/peon",
  "Pardesi ki Naukari chahiye": "/jobs/peon",
  "driver ki Naukari chahiye": "/jobs/driver",
  "Chalak ki Naukari chahiye": "/jobs/driver",
  "Palak ki Naukari chahiye": "/jobs/driver",
  "chalak ki Naukari chahiye": "/jobs/driver",
  "palak ki Naukari chahiye": "/jobs/driver",
  "drivers ki Naukari chahiye": "/jobs/driver",
  "housekeeping ki Naukari chahiye": "/jobs/housekeeping",
   "siteworkers ki Naukari chahiye": "/jobs/siteworkers",
  "siteworker ki Naukari chahiye": "/jobs/siteworkers",
  "Nirman sthal karykarta ki Naukari chahiye":"/jobs/siteworkers",
  "Nirman Sthal karykarta ki Naukari chahiye":"/jobs/siteworkers",
  "Suraksha guard ki Naukari chahiye": "/jobs/securityguard",
  "Surakshaguard ki Naukari chahiye": "/jobs/securityguard",
  "bijali Karigar ki Naukari chahie": "/jobs/electrician",
  "Nal kar ki Naukari chahie": "/jobs/plumber",
    "kar ki Naukari chahie": "/jobs/plumber",
      "Lalkare ki Naukari chahie": "/jobs/plumber",
  "Kriya Vidhi ki Naukari chahie": "/jobs/mechanic",
  "Bawarchi ki Naukari chahie": "/jobs/cooking",
  "chaprasi ki Naukari chahie": "/jobs/peon",
  "chaprasi ki Naukari":"/jobs/peon",
  "Pardesi ki Naukari chahie": "/jobs/peon",
  "Pardesi ki Naukari":"/jobs/peon",
  "driver ki Naukari chahie": "/jobs/driver",
  "Chalak ki Naukari": "/jobs/driver",
  "Palak ki Naukari": "/jobs/driver",
  "Chalak ki Naukari chahie": "/jobs/driver",
  "Palak ki Naukari chahie": "/jobs/driver",
   "chalak ki Naukari": "/jobs/driver",
  "palak ki Naukari": "/jobs/driver",
  "chalak ki Naukari chahie": "/jobs/driver",
  "palak ki Naukari chahie": "/jobs/driver",
  "drivers ki Naukari chahie": "/jobs/driver",
  "housekeeping ki Naukari chahie": "/jobs/housekeeping",
  "siteworkers ki Naukari chahie": "/jobs/siteworkers",
  "siteworker ki Naukari chahie": "/jobs/siteworkers",
  "Nirman sthal karykarta ki Naukari chahie":"/jobs/siteworkers",
  "Nirman sthal karykarta ki Naukari":"/jobs/siteworkers",
  "Nirman Sthal karykarta ki Naukari chahie":"/jobs/siteworkers",
  "Nirman Sthal karykarta ki Naukari":"/jobs/siteworkers",
  "Suraksha guard ki Naukari chahie": "/jobs/securityguard",
  "Surakshaguard ki Naukari chahie": "/jobs/securityguard",
  "Suraksha guard ki Naukari": "/jobs/securityguard",
  "post jobs": "/jobs/post",
  "post job": "/jobs/post",
  "candidates for electrician": "/candidates/electrician",
  "candidates for plumber": "/candidates/plumber",
  "candidates for mechanic": "/candidates/mechanic",
  "candidates for cook": "/candidates/cooking",
  "candidates for peon": "/candidates/peon",
  "candidates for driver": "/candidates/driver",
  "candidates for drivers": "/candidates/driver",
  "candidates for housekeeping": "/candidates/housekeeping",
  "candidates for site workers": "/candidates/siteworkers",
  "candidates for securityguard": "/candidates/securityguard",
  "candidates for security guard": "/candidates/securityguard",
  "electrician candidates": "/candidates/electrician",
  "plumber candidates": "/candidates/plumber",
  "mechanic candidates": "/candidates/mechanic",
  "cooking candidates": "/candidates/cooking",
  "peon candidates": "/candidates/peon",
  "driver candidates": "/candidates/driver",
  "drivers candidates": "/candidates/driver",
  "housekeeping candidates": "/candidates/housekeeping",
  "site worker candidates": "/candidates/siteworkers",
  "siteworker candidates": "/candidates/siteworkers",
  "securityguard candidates": "/candidates/securityguard",
  "security guard candidates": "/candidates/securityguard",
  "electrician candidate": "/candidates/electrician",
  "plumber candidate": "/candidates/plumber",
  "mechanic candidate": "/candidates/mechanic",
  "cooking candidate": "/candidates/cooking",
  "peon candidate": "/candidates/peon",
  "driver candidate": "/candidates/driver",
  "drivers candidate": "/candidates/driver",
  "housekeeping candidate": "/candidates/housekeeping",
  "site worker candidate": "/candidates/siteworkers",
  "siteworker candidate": "/candidates/siteworkers",
  "securityguard candidate": "/candidates/securityguard",
  "security guard candidate": "/candidates/securityguard",
  "candidate for electrician": "/candidates/electrician",
  "candidate for plumber": "/candidates/plumber",
  "candidate for mechanic": "/candidates/mechanic",
  "candidate for mechanics": "/candidates/mechanic",
  "candidate for cook": "/candidates/cooking",
  "candidate for peon": "/candidates/peon",
  "candidate for driver": "/candidates/driver",
  "candidate for drivers": "/candidates/driver",
  "candidate for housekeeping": "/candidates/housekeeping",
  "candidate for site workers": "/candidates/siteworkers",
  "candidate for security guard": "/candidates/securityguard",
  "candidate for securityguard": "/candidates/securityguard",
  "bijali Karigar chahie": "/candidates/electrician",
  "Nal kar chahie": "/candidates/plumber",
  "kar chahie": "/candidates/plumber",
  "Lalkare chahie": "/candidates/plumber",
  "Kriya Vidhi chahie": "/candidates/mechanic",
  "cook chahie": "/candidates/cooking",
  "chaprasi chahie": "/candidates/peon",
  "Pardesi chahie": "/candidates/peon",
  "driver chahie": "/candidates/driver",
  "Chalak chahie": "/candidates/driver",
  "Palak chahie": "/candidates/driver",
   "chalak chahie": "/candidates/driver",
  "palak chahie": "/candidates/driver",
  "drivers chahie": "/candidates/driver",
  "housekeeper chahie": "/candidates/housekeeping",
  "siteworker chahie": "/candidates/siteworkers",
  "Nirman sthal karykarta chahie": "/candidates/siteworkers",
  "Nirman Sthal karykarta chahie": "/candidates/siteworkers",
  "securityguard chahie": "/candidates/securityguard",
  "Suraksha guard chahie": "/candidates/securityguard",
  "bijali Karigar chahiye": "/candidates/electrician",
  "Nal kar chahiye": "/candidates/plumber",
  "Kriya Vidhi chahiye": "/candidates/mechanic",
  "cook chahiye": "/candidates/cooking",
  "chaprasi chahiye": "/candidates/peon",
  "Pardesi chahiye":"/candidates/peon",
  "driver chahiye": "/candidates/driver",
  "Chalak chahiye": "/candidates/driver",
  "Palak chahiye": "/candidates/driver",
   "chalak chahiye": "/candidates/driver",
  "palak chahiye": "/candidates/driver",
  "drivers chahiye": "/candidates/driver",
  "housekeeper chahiye": "/candidates/housekeeping",
   "siteworker chahiye": "/candidates/siteworkers",
  "Nirman sthal karykarta chahiye": "/candidates/siteworkers",
  "Nirman Sthal karykarta chahiye": "/candidates/siteworkers",
  "Suraksha guard chahiye": "/candidates/securityguard",
  "security guard chahiye": "/candidates/securityguard",
  "Bawarchi chahie": "/candidates/cooking",
  "Bawarchi chahiye": "/candidates/cooking",

  registration: "/user/register",
  register: "/user/register"
};
export default urls;